angular.module('impactx.dashboard')
    .directive('ixInnerDashboard', function() {
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'modules/dashboard/templates/dashboard.inner.tmpl.html'
        };
    });